import React, { useState, useEffect } from 'react'
import './HeroCarousel.css'

const HeroCarousel = ({ images = [], autoPlayInterval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // 自动播放
  useEffect(() => {
    if (images.length <= 1) return

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
    }, autoPlayInterval)

    return () => clearInterval(interval)
  }, [images.length, autoPlayInterval])

  const goToSlide = (index) => {
    setCurrentIndex(index)
  }

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    )
  }

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    )
  }

  if (!images || images.length === 0) {
    return null
  }

  return (
    <section className="hero-banner">
      <div className="banner-container">
        {images.map((image, index) => (
          <div
            key={index}
            className={`banner-slide ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image.url || image})` }}
          >
            {image.overlay && (
              <div className="banner-overlay">
                {image.overlay.title && <h1 className="banner-title">{image.overlay.title}</h1>}
                {image.overlay.subtitle && <p className="banner-subtitle">{image.overlay.subtitle}</p>}
                {image.overlay.cta && (
                  <a href={image.overlay.cta.link} className="banner-cta">
                    {image.overlay.cta.text}
                  </a>
                )}
              </div>
            )}
          </div>
        ))}

        {/* 导航箭头 */}
        {images.length > 1 && (
          <>
            <button 
              className="banner-arrow banner-arrow-left" 
              onClick={goToPrevious}
              aria-label="Previous slide"
            >
              ‹
            </button>
            <button 
              className="banner-arrow banner-arrow-right" 
              onClick={goToNext}
              aria-label="Next slide"
            >
              ›
            </button>
          </>
        )}

        {/* 指示器 */}
        {images.length > 1 && (
          <div className="banner-indicators">
            {images.map((_, index) => (
              <button
                key={index}
                className={`banner-indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default HeroCarousel
